import React from 'react';
import PropTypes from 'prop-types';
import { Button } from '@material-ui/core';
import ArrowBackIcon from '@material-ui/icons/ArrowBack';
import { defineMessages, FormattedMessage } from 'react-intl';

const messages = defineMessages({
  BACK: {
    id: 'BACK',
    defaultMessage: 'Back',
  },
});

function BackBtn({ onBack }) {
  return (
    <Button onClick={onBack}>
      <ArrowBackIcon style={{ marginRight: '12px' }} />
      <FormattedMessage {...messages.BACK} />
    </Button>
  );
}

BackBtn.propTypes = {
  onBack: PropTypes.func.isRequired,
};

export default BackBtn;
